
import React from 'react';
import MultiSelectField from './MultiSelectField';
import WniCheckboxGroup from '../CheckboxField/WniCheckboxGroup';

const MultiSelectNextField = (props) => {
    return <MultiSelectField {...props} checkboxGroupComponent={WniCheckboxGroup} />
};
export default MultiSelectNextField;
